module.exports = __webpack_public_path__ + "static/media/Danger.8815fed7.svg";